export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";